import { render, staticRenderFns } from "./DonorAttachmentsPrint.vue?vue&type=template&id=73cb9afd"
import script from "./DonorAttachmentsPrint.vue?vue&type=script&lang=js"
export * from "./DonorAttachmentsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports